import React from 'react';
import LoginContainer from '../../../Containers/UserContainer/Login';

const LoginScreen = () => {
  return <LoginContainer />;
};

export default LoginScreen;
